import * as Accordion from '@radix-ui/react-accordion';
import { usePathname } from 'next/navigation';

import { Link } from '@/components/link';
import { openNavStyles } from '@/components/modules/app-navigation/open';
import { OpenItemContent } from '@/components/modules/app-navigation/open/item/content';
import { OpenItemHeader } from '@/components/modules/app-navigation/open/item/header';
import { AppNavigationSearchHistory } from '@/components/modules/app-navigation/search-history';
import { useFeatureNotifications } from '@/hooks/use-feature-notifications';
import { AppNavItem } from '@/lib/constants';
import { isNavItemActive } from '@/utils/helpers/page-urls';

export interface OpenItemProps {
  item: AppNavItem;
  isOpen?: boolean;
  visibility: 'visible' | 'hidden';
}
const OpenItem = ({ isOpen, item, visibility }: OpenItemProps) => {
  const pathname = usePathname() || '';
  const { isFeatureSeen } = useFeatureNotifications(item.notification?.id);

  const parentIsActive = item.subItems.some((subItem) => isNavItemActive({ asPath: pathname, itemUrl: subItem.url }));

  const { subNavList, subNavLink, subNavLinkBorder } = openNavStyles({ isOpen });
  return (
    <Accordion.Item value={item.id} key={item.id}>
      <OpenItemHeader
        isOpen={isOpen}
        label={item.label}
        showNotificationDot={item.notification && !isFeatureSeen}
        parentIsActive={parentIsActive}
        visibility={visibility}
        iconComponent={item.icon}
        notificationContent={item.notification?.tooltipContent}
        hasSubItems={Boolean(item.subItems.length)}
      />
      {item.subItems && (
        <OpenItemContent isOpen={isOpen} visibility={visibility}>
          <ul className={subNavList()}>
            {item.subItems.map((subItem, index) => (
              <li key={index}>
                <Link
                  href={subItem.url}
                  className={subNavLink({ isActive: isNavItemActive({ asPath: pathname, itemUrl: subItem.url }) })}
                >
                  {subItem.label}
                  <span
                    className={subNavLinkBorder({
                      isActive: isNavItemActive({ asPath: pathname, itemUrl: subItem.url }),
                    })}
                  />
                </Link>
              </li>
            ))}
            {item.id === 'routing' && <AppNavigationSearchHistory />}
          </ul>
        </OpenItemContent>
      )}
    </Accordion.Item>
  );
};

export { OpenItem };
